import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { SpecialPromotionsCollectionModel } from "@store/Types/SpecialPromotionModel";

const specialPromotionsUrl = "/api/v1/poolcorp/promotions";

export function getSpecialPromotions() {
    return get<SpecialPromotionsCollectionModel>(`${specialPromotionsUrl}/`);
}
